<template>
  <div>
    <v-dialog v-model="saveDialog" persistent max-width="75%">
      <v-form
        ref="form"
        lazy-validation
      >
      <v-card>
        <v-card-title style="background-color: #2b3990">
          <span class="headline white--text">{{ titleForm }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="newStaff"
                  label="Staff"
                  :items="staffList"
                  item-text="Name"
                  item-value="_id"
                  required
                  :rules="[v => !!v || 'Staff is Required']"
                  @change="getMissedSchedule"
                >
                  <template v-slot:prepend-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field v-model="searchTerm" placeholder="Search" @input="searchStaff" clearable></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>

              <v-col cols="12">
                <v-data-table
                      :headers="headers"
                      :items="schedules"
                      item-key="shiftId"
                      sort-asc
                      class="elevation-1"
                      :loading="isLoading"
                      loading-text="Loading Data"
                      height="350"
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon small class="mr-2" @click="viewSchedule(item)">
                        mdi-eye
                      </v-icon>

                    </template>
                  </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()"
          >Close</v-btn
          >
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="saveScheduleDialog" persistent max-width="75%">
      <v-form
        ref="form"
        lazy-validation
      >
      <v-card>
        <v-card-title style="background-color: #2b3990">
          <span class="headline white--text">Manual Clock Time</span>
        </v-card-title>
        <v-card-text>
          <v-container>

            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-datetime-picker
                  ref="newClockIn"
                  v-model="ClockIn"
                  time-format="hh:mm a"
                  date-format="yyyy-MM-dd"
                  label="Clock In"
                ></v-datetime-picker>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-datetime-picker
                      ref="newClockOut"
                      v-model="ClockOut"
                      time-format="hh:mm a"
                      date-format="yyyy-MM-dd"
                      label="Clock Out"
                    ></v-datetime-picker>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  ref="note"
                  v-model="Note"
                  clearable
                  clear-icon="mdi-close-circle"
                  label="Notes"
                  required
                  :rules="[v => !!v || 'Note is Required']"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="success" @click="addTimesheet()"
          >Add Clock Time</v-btn>
          <v-btn color="blue darken-1" text @click="saveScheduleDialog = false"
          >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>
</div>
</template>

<script>
  import axios from 'axios'
  import { mapState, mapMutations } from "vuex";
  import moment from "moment";
  import {datetime, RRule} from 'rrule';

  const url = require("../../client_config/config").url;

  export default {
    props: {
      titleForm: String,
      staff: Array
    },

    data: () => ({
      ClockIn: null,
      ClockOut: null,
      Note: "",
      newStaff: "",
      searchTerm: "",
      staffCopy: [] ,
      staffList: [],
      headers: [
        {
            text: "Schedule Date",
            align: "start",
            sortable: true,
            value: "date",
        },
        {text: "Clock In", value: "ClockIn"},
        {text: "Clock Out", value: "ClockOut"},
        { text: "Actions", value: "actions", sortable: false },
      ],
      schedules: [],
      isLoading: false,
      saveScheduleDialog: false,
      selectedSchedule: [],
    }),

    watch: {
      staff(nval){
        this.staffList = nval;
        this.staffCopy = [...nval];
      }
    },

    computed: {
      ...mapState({
        saveDialog: state => state.timesheet.saveDialog,
      }),
    },

    async created(){
      this.staffCopy = [...this.staff];
      this.staffList = this.staff;
    },

    methods: {
      ...mapMutations({
        setSnackbar: "SET_SNACKBAR",
      }),

      ...mapMutations("timesheet", {
        setSaveDialog: "SET_SAVE_DIALOG",
      }),

      searchStaff() {
        // console.log(e);
        if (!this.searchTerm) {
          this.staffList = this.staffCopy;
        }else{
          this.staffList = this.staffCopy.filter((item) => {
            return this.searchTerm.toLowerCase().split(' ').every(v => item.Name.toLowerCase().includes(v))
          });
        }

      },

      staffChange(){
        this.staffList = this.staffCopy;
      },

      async addTimesheet(){
        const ClockIn = moment(moment(new Date(this.ClockIn)).format("YYYY-MM-DD hh:mm a")).utc();
        const ClockOut = (this.ClockOut !== "" && this.ClockOut !== null) ?  moment(moment(new Date(this.ClockOut)).format("YYYY-MM-DD hh:mm a")).utc() : "";
        const difference = moment(this.ClockOut).diff(moment(this.ClockIn));

        if (this.$refs.form.validate()) {

          if(difference < 0){
            this.setSnackbar({
              show: true,
              text: "Clock Out date must be greater than Clock In date.",
              color: "red accent-4",
            });
          }else if(this.ClockIn !== "Invalid Date" && this.ClockOut !== "" && this.ClockOut != null){

            const { _id, employee, units, ClientId, StartDate, EndDate, Rate } = this.selectedSchedule;
            const req_body = {
              ClockIn: ClockIn,
              ClockOut: ClockOut,
              Note: this.Note,
              ScheduleId: _id,
              EmployeeId: employee,
              ClockInSchedule: StartDate,
              ClockOutSchedule: EndDate,
              ClientId: ClientId,
              Program: units,
              Rate: Rate
            };

            await axios.post(`${url}/timeSheets/manualClock`, req_body ).then(res => {
              if (res.status === 400) {
                res.json().then(function(data) {
                  this.setSnackbar({
                    show: true,
                    text: data.msg,
                    color: "red accent-4",
                  });
                });
              }else{
                this.setSnackbar({
                  show: true,
                  text: "The time sheet has been added successfully.",
                  color: "green accent-4",
                });

              }
            }).finally(() => {
              this.saveScheduleDialog = false;
              this.getMissedSchedule();
              this.Note = "";
            });

          }else{
            this.setSnackbar({
              show: true,
              text: "Invalid Dates",
              color: "red accent-4",
            });
          }

        }


      },

      async getMissedSchedule(){
        this.isLoading = true;
        this.schedules = [];
        await axios.get(`${url}/shifts/getMissedSchedule/${this.newStaff}`)
          .then( response =>{
            response.data.schedules.forEach((value) => {
              if (value.isRecurringEvent === "No") {
                value.ClockIn = moment(new Date(value.StartDate)).format("hh:mm A");
                value.ClockOut = moment(new Date(value.EndDate)).format("hh:mm A");
                value.date = moment(new Date(value.StartDate)).format("YYYY-MM-DD");
                value.Rate = value.user?.Rate || 0;
                
                this.schedules.push(value);
              } else if (value.isRecurringEvent === "Yes") {
                const recurringYear = moment(value.StartDate).utc().year();
                const recurringMonth = moment(value.StartDate).utc().format("M");
                const recurringDay = moment(value.StartDate).utc().format("D");
                const recurringHour = moment(value.StartDate).utc().format("HH");
                const recurringMinute = moment(value.StartDate).utc().format("mm");

                const recurringEndYear = moment(value.EndDate).utc().year();
                const recurringEndMonth = moment(value.EndDate).utc().format("M");
                const recurringEndDay = moment(value.EndDate).utc().format("D");
                const recurringEndHour = moment(value.EndDate).utc().format("HH");
                const recurringEndMinute = moment(value.EndDate).utc().format("mm");

                const recurringTypeSwitch = (eventType) => ({
                  "Daily": RRule.DAILY,
                  "Weekly": RRule.WEEKLY,
                  "Monthly": RRule.MONTHLY,
                  "Annually": RRule.YEARLY,
                })[eventType];

                const recurringDate = new RRule({
                  freq: recurringTypeSwitch(value.typeOfRecurringEvent),
                  dtstart: datetime(parseInt(recurringYear), parseInt(recurringMonth), parseInt(recurringDay), parseInt(recurringHour), parseInt(recurringMinute)),
                  until: datetime(parseInt(recurringEndYear), parseInt(recurringEndMonth), parseInt(recurringEndDay), parseInt(recurringEndHour), parseInt(recurringEndMinute)),
                  interval: 1
                });

                const dateRec = recurringDate.all().map(date =>
                  moment(date).format("YYYY-MM-DD")
                );

                dateRec.forEach(itemDate => {
                  let timeStart = moment(value.StartDate).format("hh:mm A");
                  let timeEnd = moment(value.EndDate).format("hh:mm A");
                  let newDate = moment(itemDate).format("YYYY-MM-DD");
                  let newStartDate = new Date(`${newDate} ${timeStart}`);
                  let newEndDate = new Date(`${newDate} ${timeEnd}`);

                  if (moment(newStartDate).format("YYYY-MM-DD") < moment.utc(new Date()).format("YYYY-MM-DD")) {
                    // Check if specific recurring date is already clock in.
                    let result = value.recurringDatesClockIn.some(val => {
                      return moment(val.RecurringDateSchedule).format("YYYY-MM-DD") == newDate;
                    })
                    if (!result) {
                      this.schedules.push({
                        _id: value._id,
                        ClientId: value.ClientId,
                        Company: value.Company,
                        StartDate: newStartDate,
                        EndDate: newEndDate,
                        employee: value.employee,
                        units: value.units,
                        user: value.user,
                        ClockIn: moment(newStartDate).format("hh:mm A"),
                        ClockOut: moment(newEndDate).format("hh:mm A"),
                        date: moment(newStartDate).format("YYYY-MM-DD"),
                        Rate: value.user?.Rate || 0,
                        isRecurringEvent: value.isRecurringEvent,
                        typeOfRecurringEvent: value.typeOfRecurringEvent,
                      });
                    }
                  }
                });
              }
            });
          })
          .finally(() => {
            this.schedules.sort((a,b) => {
              return moment.utc(new Date(b.date)) - moment.utc(new Date(a.date));
            });
            
            this.isLoading = false
          });
      },

      viewSchedule(schedule){
        this.saveScheduleDialog = true;
        this.selectedSchedule = schedule;
        this.ClockIn = moment(schedule.StartDate).format("YYYY-MM-DD hh:mm A");
        this.ClockOut = moment(schedule.EndDate).format("YYYY-MM-DD hh:mm A");
        // console.log(schedule);
      },

      close(){
        this.$refs.form.resetValidation();
        this.setSaveDialog(false);
        this.schedules = [];
        this.newStaff = "";
        //this.newStaff = "";
        //this.newNote = "";
      },

    },

  }
</script>
